import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaWhatsapp, FaUser, FaEnvelope, FaCommentAlt, FaPaperPlane, FaPhoneAlt, FaMapMarkerAlt, FaLinkedinIn, FaTwitter, FaFacebook, FaInstagram, FaCheckCircle, FaArrowRight } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import CONFIG from "../config";
const ContactUs = () => {
    const navigate = useNavigate();
    const [isScrolled, setIsScrolled] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
    });

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null); // success, error

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus(null);

        try {
            const { name, email, phone, subject, message } = formData;

            // Prepare payload
            const payload = {
                name,
                email,
                subject: subject || "New Contact Inquiry",
                message: `Phone: ${phone}\n\n${message}`
            };

            const response = await fetch(`${CONFIG.BASE_URL}/mail/send-lead`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.ok) {
                setStatus('success');
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    subject: "",
                    message: ""
                });
                alert("Message sent successfully!");
            } else {
                setStatus('error');
                alert(data.error || "Failed to send message.");
            }
        } catch (error) {
            console.error("Error sending message:", error);
            setStatus('error');
            alert("An error occurred. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const contactMethods = [
        {
            icon: <FaEnvelope className="text--primary" />,
            title: "EMAIL US",
            value: "reachus@pitlabs.in",
            link: "mailto:reachus@pitlabs.in",
            isHighlight: false
        },
        {
            icon: <FaPhoneAlt className="text--primary" />,
            title: "CALL US",
            value: "+91 98500 33755",
            link: "tel:+919850033755",
            isHighlight: false
        },
        {
            icon: <FaWhatsapp className="text--primary" />,
            title: "WHATSAPP",
            value: "Chat with us",
            link: "https://wa.me/919850033755",
            isHighlight: false
        },
        {
            icon: <FaMapMarkerAlt className="text--primary" />,
            title: "VISIT US",
            value: "D91, Kalpataru Jade, Baner, Pune - 411045",
            link: "#",
            isHighlight: false
        }
    ];

    return (
        <div className="min-h-screen bg-white overflow-x-hidden">
            {/* Header - Reused from LandingPage */}
            <motion.header
                className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled
                    ? "bg-white/95 backdrop-blur-md shadow-lg"
                    : "bg-white/95 backdrop-blur-md shadow-lg" // Always white background for Contact page legibility or consistent look
                    }`}
                initial={{ y: -100 }}
                animate={{ y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center py-4">
                        <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            className="text-3xl font-bold text--primary"
                        >
                            <Link to="/" className="flex items-center">
                                <motion.img
                                    whileHover={{ scale: 1.05 }}
                                    src="/Ayurmaxfinal.png"
                                    alt="Ayumax"
                                    className="h-16 md:h-20"
                                />
                            </Link>
                        </motion.div>
                        <nav className="hidden md:flex items-center space-x-8">
                            <Link
                                to="/#features"
                                className="hover:text--primary transition-colors text-gray-700"
                            >
                                Features
                            </Link>
                            <Link
                                to="/#how"
                                className="hover:text--primary transition-colors text-gray-700"
                            >
                                How It Works
                            </Link>
                            <Link
                                to="/#pricing"
                                className="hover:text--primary transition-colors text-gray-700"
                            >
                                Pricing
                            </Link>
                            <Link
                                to="/contact-us"
                                className="text--primary font-bold transition-colors"
                            >
                                Contact
                            </Link>
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => navigate("/login")}
                                className="px-6 py-2 rounded-full font-semibold transition-all bg--primary text-white hover:bg--dark shadow-lg"
                            >
                                Login
                            </motion.button>
                        </nav>
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => navigate("/login")}
                            className="md:hidden px-4 py-2 bg--primary text-white rounded-full font-semibold text-sm shadow-lg"
                        >
                            Login
                        </motion.button>
                    </div>
                </div>
            </motion.header>

            {/* Main Content */}
            <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 container mx-auto max-w-7xl">
                <div className="text-center mb-16">
                    <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
                        Contact <span className="text--primary">Assetsoft</span>
                    </h1>
                    <div className="h-1.5 w-24 bg-ayurmax-primary mx-auto rounded-full mb-8"></div>
                    <p className="text-gray-600 max-w-2xl mx-auto text-lg leading-relaxed">
                        Have questions about our Ayurvedic clinic management software? <br className="hidden md:block" />
                        We're here to help you modernize your practice.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
                    {/* Left Column: Contact Methods */}
                    <div className="space-y-6">
                        {contactMethods.map((method, index) => (
                            <motion.a
                                key={index}
                                href={method.link}
                                target={method.link.startsWith("http") ? "_blank" : "_self"}
                                rel="noreferrer"
                                whileHover={{ y: -5, boxShadow: "0 10px 30px -10px rgba(0, 0, 0, 0.1)" }}
                                className={`flex items-center gap-6 p-6 rounded-2xl border transition-all cursor-pointer group ${method.isHighlight
                                    ? "bg-green-50/50 border-green-200 outline outline-2 outline-green-100"
                                    : "bg-white border-gray-100 hover:border-gray-200 shadow-[0_2px_10px_-4px_rgba(0,0,0,0.05)]"
                                    }`}
                            >
                                <div className={`w-14 h-14 rounded-xl flex items-center justify-center text-xl shrink-0 transition-colors ${method.isHighlight ? "bg-green-100 text-ayurmax-primary" : "bg-gray-50 text-gray-600 group-hover:bg-green-50 group-hover:text-ayurmax-primary"
                                    }`}>
                                    {method.icon}
                                </div>
                                <div>
                                    <p className="text-xs font-bold text-gray-400 tracking-widest uppercase mb-1.5">{method.title}</p>
                                    <p className={`font-bold text-lg md:text-xl ${method.isHighlight ? "text-gray-900" : "text-gray-800"}`}>
                                        {method.value}
                                    </p>
                                </div>
                            </motion.a>
                        ))}

                        <div className="pt-10">
                            <p className="text-xs font-bold text-gray-400 tracking-widest uppercase mb-6">Connect with us</p>
                            <div className="flex gap-4">
                                {[FaLinkedinIn, FaTwitter, FaFacebook, FaInstagram].map((Icon, i) => (
                                    <motion.a
                                        key={i}
                                        href="#"
                                        whileHover={{ y: -3 }}
                                        className="w-12 h-12 rounded-xl border border-gray-200 flex items-center justify-center text-gray-400 hover:text-ayurmax-primary hover:border-green-200 hover:bg-green-50 transition-all shadow-sm"
                                    >
                                        <Icon size={20} />
                                    </motion.a>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Form */}
                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.2 }}
                        className="bg-white p-8 md:p-10 rounded-3xl shadow-[0_10px_60px_-15px_rgba(0,0,0,0.08)] border border-gray-100"
                    >
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="space-y-2">
                                    <label className="text-xs font-bold text-gray-500 uppercase tracking-widest ml-1">Full Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Your Name"
                                        className="w-full px-5 py-4 bg-gray-50 rounded-xl border-none outline-none focus:ring-2 focus:ring-ayurmax-primary/20 transition-all font-medium text-gray-700 placeholder-gray-400"
                                        required
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label className="text-xs font-bold text-gray-500 uppercase tracking-widest ml-1">Email Address</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="you@email.com"
                                        className="w-full px-5 py-4 bg-gray-50 rounded-xl border-none outline-none focus:ring-2 focus:ring-ayurmax-primary/20 transition-all font-medium text-gray-700 placeholder-gray-400"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <label className="text-xs font-bold text-gray-500 uppercase tracking-widest ml-1">Phone Number (Optional)</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="+91..."
                                    className="w-full px-5 py-4 bg-gray-50 rounded-xl border-none outline-none focus:ring-2 focus:ring-ayurmax-primary/20 transition-all font-medium text-gray-700 placeholder-gray-400"
                                />
                            </div>

                            <div className="space-y-2">
                                <label className="text-xs font-bold text-gray-500 uppercase tracking-widest ml-1">Subject</label>
                                <input
                                    type="text"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    placeholder="How can we help?"
                                    className="w-full px-5 py-4 bg-gray-50 rounded-xl border-none outline-none focus:ring-2 focus:ring-ayurmax-primary/20 transition-all font-medium text-gray-700 placeholder-gray-400"
                                />
                            </div>

                            <div className="space-y-2">
                                <label className="text-xs font-bold text-gray-500 uppercase tracking-widest ml-1">Your Message</label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="5"
                                    placeholder="Tell us about your needs..."
                                    className="w-full px-5 py-4 bg-gray-50 rounded-xl border-none outline-none focus:ring-2 focus:ring-ayurmax-primary/20 transition-all font-medium text-gray-700 placeholder-gray-400 resize-none"
                                    required
                                ></textarea>
                            </div>

                            <motion.button
                                whileHover={{ scale: 1.01 }}
                                whileTap={{ scale: 0.99 }}
                                type="submit"
                                disabled={loading}
                                className={`w-full py-4 bg-ayurmax-primary text-white rounded-xl font-bold text-lg shadow-lg shadow-ayurmax-primary/30 transition-all ${loading ? 'opacity-70 cursor-not-allowed' : 'hover:bg-ayurmax-dark'}`}
                            >
                                {loading ? 'Sending...' : 'Send Message'}
                            </motion.button>
                        </form>
                    </motion.div>
                </div>
            </div>

            {/* Floating WhatsApp Button */}
            <motion.a
                href="https://wa.me/919850033755"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, rotate: 10 }}
                whileTap={{ scale: 0.9 }}
                className="fixed bottom-8 right-8 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl flex items-center justify-center cursor-pointer hover:bg-[#20bd5a] transition-colors"
            >
                <FaWhatsapp size={32} />
            </motion.a>
        </div>
    );
};

export default ContactUs;
